<template>
  <div class="dispensaciones-container">
    <h4 class="mb-4">Historial de Dispensaciones</h4>

    <div class="search-bar mb-3">
      <input type="text" v-model="searchQuery" placeholder="Buscar por código, nombre o fecha" class="form-control" />
    </div>

    <div v-if="filteredDispensaciones.length === 0" class="alert alert-info">
      No hay dispensaciones registradas para este usuario.
    </div>

    <div class="dispensacion-card" v-for="disp in paginatedDispensaciones" :key="disp.id">
      <div class="card-header d-flex justify-content-between align-items-center">
        <strong class="text-primary">{{ disp.producto_final_envasado.tipo_producto }}</strong>
        <span class="text-muted small">
          {{ formatFecha(disp.fecha_dispensacion) }}
        </span>
        <button class="btn btn-secondary btn-sm" @click="editarDispensacion(disp)"><font-awesome-icon :icon="['fas', 'edit']" /> Editar</button>
      </div>

      <div class="card-body">
        <div class="row mb-2">
          <div class="col-md-6">
            <strong>Producto:</strong>
            <div>{{ disp.producto_final_envasado.codigo }}</div>
          </div>
          <div class="col-md-6">
            <strong>Envase: {{ disp.producto_final_envasado.tipo_envase }}</strong>
            <div>
              {{ disp.producto_final_envasado.peso_por_unidad }}
              {{ disp.producto_final_envasado.unidad_medida_peso_envase }}
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-6">
            <strong>Cantidad entregada:</strong> {{ disp.cantidad_entregada }}
          </div>
          <div class="col-md-6" v-if="disp.anulado">
            <strong class="text-danger">Anulado</strong><br />
            <small><em>Justificación:</em> {{ disp.justificacion_anulacion }}</small>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination-controls mt-3">
      <button class="btn btn-primary" :disabled="currentPage === 1" @click="currentPage--"><font-awesome-icon :icon="['fas', 'arrow-left']" /> Anterior</button>
      <span>Página {{ currentPage }} de {{ totalPages }}</span>
      <button class="btn btn-primary" :disabled="currentPage === totalPages" @click="currentPage++">Siguiente <font-awesome-icon :icon="['fas', 'arrow-right']" /></button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  props: {
    usuario: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dispensaciones: [],
      searchQuery: '',
      currentPage: 1,
      itemsPerPage: 5
    }
  },
  computed: {
    filteredDispensaciones() {
      return this.dispensaciones.filter(disp => {
        const searchLower = this.searchQuery.toLowerCase();
        return disp.producto_final_envasado.codigo.toLowerCase().includes(searchLower) ||
               disp.producto_final_envasado.tipo_producto.toLowerCase().includes(searchLower) ||
               this.formatFecha(disp.fecha_dispensacion).toLowerCase().includes(searchLower);
      });
    },
    paginatedDispensaciones() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredDispensaciones.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredDispensaciones.length / this.itemsPerPage);
    }
  },
  methods: {
    async fetchDispensaciones() {
      try {
        const usuario_medicinal_id = this.usuario.id
        const { data } = await axios.get(`/api/dispensacion-medicinal-usuario/${usuario_medicinal_id}`)
        this.dispensaciones = data
      } catch (error) {
        console.error('Error al obtener dispensaciones:', error)
      }
    },
    formatFecha(fecha) {
      return new Date(fecha).toLocaleString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    editarDispensacion(dispensacion) {
      this.$emit('editarDispensacion', dispensacion)
    }
  },
  mounted() {
    this.fetchDispensaciones()
  }
}
</script>

<style scoped>
.dispensaciones-container {
  max-width: 900px;
  margin: 0 auto;
}

.dispensacion-card {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin-bottom: 1rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-header {
  background-color: #f8f9fa;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.card-body {
  padding: 1rem;
}

.search-bar {
  display: flex;
  justify-content: center;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
